// Human-readable list joining for prose. Use this anywhere user-facing copy
// stitches a variable number of items into a sentence — never hand-roll
// `.join(' and ')`, which produces "a and b and c" and breaks at one item.
//
// Intl.ListFormat gives the correct Oxford-free English form at every count:
//   []            → ''
//   ['a']         → 'a'
//   ['a','b']     → 'a and b'
//   ['a','b','c'] → 'a, b and c'
// and 'or' for the disjunction variant. Casing of each item is the caller's
// job — pass items already cased for their position in the sentence.

const conjunction = new Intl.ListFormat('en-GB', { style: 'long', type: 'conjunction' });
const disjunction = new Intl.ListFormat('en-GB', { style: 'long', type: 'disjunction' });

// items: string[]. type: 'and' (default) | 'or'.
export function formatList(items, type = 'and') {
  const clean = (items || []).filter((s) => s != null && s !== '');
  if (clean.length === 0) return '';
  return (type === 'or' ? disjunction : conjunction).format(clean);
}
